import { render, staticRenderFns } from "./VAWAvatar.vue?vue&type=template&id=508a7c51&scoped=true"
import script from "./VAWAvatar.vue?vue&type=script&lang=js"
export * from "./VAWAvatar.vue?vue&type=script&lang=js"
import style0 from "./VAWAvatar.vue?vue&type=style&index=0&id=508a7c51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508a7c51",
  null
  
)

export default component.exports